module.exports = __webpack_public_path__ + "static/media/bg_transparent.1a5d4801.png";